import { mutator } from 'satcheljs';
import initializeCalendarProcessingOptions from '../../actions/initializeCalendarProcessingOptions';
import getStore from '../store/store';
/**
 * Initialize the calendar processing options in store
 */
export default mutator(initializeCalendarProcessingOptions, function (actionMessage) {
    getStore().calendarProcessingOptions = actionMessage.calendarProcessingOptions;
});
//# sourceMappingURL=initializeCalendarProcessingOptionsMutator.js.map